import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e7654c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "s-user-menu" }
const _hoisted_2 = { class: "s-user-menu__icon" }
const _hoisted_3 = {
  key: 0,
  class: "s-user-menu__window"
}
const _hoisted_4 = {
  key: 0,
  class: "s-user-menu__item"
}
const _hoisted_5 = {
  key: 1,
  class: "s-user-menu__item"
}
const _hoisted_6 = { class: "s-user-menu__element" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "s-user-menu__divider" }, null, -1))
const _hoisted_8 = {
  key: 2,
  class: "s-user-menu__item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SIcon = _resolveComponent("SIcon")!
  const _component_STextElement = _resolveComponent("STextElement")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "s-user-menu__button",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickProfileButton && _ctx.handleClickProfileButton(...args)), ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SIcon, {
          name: _ctx.profileIcon.name,
          color: _ctx.profileIcon.color
        }, null, 8, ["name", "color"])
      ])
    ]),
    (_ctx.state.isOpened)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.userClasses),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.user.handler && _ctx.user.handler(...args)))
                }, [
                  (_ctx.user.title)
                    ? (_openBlock(), _createBlock(_component_STextElement, {
                        key: 0,
                        variant: "small-medium",
                        color: "white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.user.title), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.user.text)
                    ? (_openBlock(), _createBlock(_component_STextElement, {
                        key: 1,
                        variant: "x-small-medium",
                        color: "stroke"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.user.text), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isDefaultSlot)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_7,
          (_ctx.logout)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "s-user-menu__element s-user-menu__element_active s-user-menu__element_logout",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout.handler && _ctx.logout.handler(...args)))
                }, [
                  (_ctx.logout.icon)
                    ? (_openBlock(), _createBlock(_component_SIcon, {
                        key: 0,
                        name: _ctx.logout.icon,
                        color: "gray",
                        size: "s"
                      }, null, 8, ["name"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_STextElement, {
                    variant: "x-small-medium",
                    color: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.logout.title), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_click_outside, _ctx.handleClickOutside]
        ])
      : _createCommentVNode("", true)
  ]))
}